import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/bullet.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/sensoryResearch/collage.png");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/sensoryResearch/foodandbeverage.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/sensoryResearch/franchise.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/sensoryResearch/petfood.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/sensoryResearch/sensory_our.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/sensoryResearch/sensory_test.png");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/sensoryResearch/skincare.svg");
;
import(/* webpackMode: "eager" */ "/app/public/slm/icon/home.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/ModalOpener/index.tsx");
